import { SHOW_UPDATED_MESSAGING_ON_AUTO_ENROLLED_FREE_TRIAL_240509 } from "@faire/web-api/indigofair/settings/SHOW_UPDATED_MESSAGING_ON_AUTO_ENROLLED_FREE_TRIAL_240509";

import { getSettingValueWithoutAssignment } from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingShowAutoEnrollUpdate = (): boolean =>
  getSettingValueWithoutAssignment(
    SHOW_UPDATED_MESSAGING_ON_AUTO_ENROLLED_FREE_TRIAL_240509,
    false
  );
